package com.appsyde.shared.presentation.screen.component

import androidx.compose.runtime.Composable
import com.appsyde.shared.presentation.style.style.AppStylesLayout
import org.jetbrains.compose.web.dom.*

@Composable
fun Spacer() {
    Div(attrs = { classes(AppStylesLayout.spacerSm) })
}

@Composable
fun SpacerSmall() {
    Div(attrs = { classes(AppStylesLayout.spacerXs) })
}

@Composable
fun SpacerXSmall() {
    Div(attrs = { classes(AppStylesLayout.spacerXxs) })
}
